export default __webpack_public_path__ + "static/media/blank.014e7654.svg";